// extracted by mini-css-extract-plugin
module.exports = {"search-container":"search-container__DsmL7","search-input-label":"search-input-label__WUMhs","desktop":"desktop__AbJUi","mobile":"mobile__s35hD"};